
import * as z from "zod";

export const practiceAreas = [
  { label: "Corporate Law", value: "corporate" },
  { label: "Litigation", value: "litigation" },
  { label: "Real Estate", value: "real_estate" },
  { label: "Intellectual Property", value: "ip" },
  { label: "Family Law", value: "family" },
  { label: "Criminal Law", value: "criminal" },
  { label: "Immigration", value: "immigration" },
  { label: "Employment Law", value: "employment" },
  { label: "Tax Law", value: "tax" },
  { label: "Environmental Law", value: "environmental" },
  { label: "Healthcare", value: "healthcare" },
  { label: "Other", value: "other" }
];

export const roleOptions = [
  { label: "Attorney/Partner", value: "attorney_partner" },
  { label: "Associate", value: "associate" },
  { label: "Legal Operations", value: "legal_ops" },
  { label: "IT/Technology", value: "it_tech" },
  { label: "Administration", value: "admin" },
  { label: "C-Suite", value: "c_suite" },
  { label: "Other", value: "other" }
];

export const timezones = [
  { label: "Eastern Time (ET)", value: "America/New_York" },
  { label: "Central Time (CT)", value: "America/Chicago" },
  { label: "Mountain Time (MT)", value: "America/Denver" },
  { label: "Pacific Time (PT)", value: "America/Los_Angeles" },
  { label: "Alaska Time (AKT)", value: "America/Anchorage" },
  { label: "Hawaii-Aleutian Time (HST)", value: "Pacific/Honolulu" }
];

export const discoverySessionSchema = z.object({
  firstName: z.string().min(1, "First name is required"),
  lastName: z.string().min(1, "Last name is required"),
  email: z.string().email("Please enter a valid work email"),
  firmName: z.string().min(1, "Firm name is required"),
  role: z.string({
    required_error: "Please select your role"
  }),
  practiceAreas: z.array(z.string()).min(1, "Please select at least one practice area"),
  challenges: z.string().max(500, "Please limit your response to 500 characters").optional(),
  goals: z.string().max(500, "Please limit your response to 500 characters").optional(),
  preferredDate: z.date({
    required_error: "Please select a preferred date"
  }),
  preferredTime: z.string({
    required_error: "Please select a preferred time"
  }),
  timezone: z.string({
    required_error: "Please select your timezone"
  }),
  consent: z.boolean().refine(value => value === true, {
    message: "You must consent to receive communications"
  })
});

export type DiscoverySessionFormData = z.infer<typeof discoverySessionSchema>;

export const preferredTimes = [
  { label: "9:00 AM", value: "09:00" },
  { label: "10:00 AM", value: "10:00" },
  { label: "11:00 AM", value: "11:00" },
  { label: "12:00 PM", value: "12:00" },
  { label: "1:00 PM", value: "13:00" },
  { label: "2:00 PM", value: "14:00" },
  { label: "3:00 PM", value: "15:00" },
  { label: "4:00 PM", value: "16:00" },
  { label: "5:00 PM", value: "17:00" }
];
